import { ComponentProps } from "react";
import { useSelector } from "react-redux";

import { Box, Logo as SenekitLogo } from "@seneca/senekit";
import { ResponsiveProp } from "@seneca/senekit/out/types";

import { getRegion } from "seneca-common/features/user/state";

import { getAppName, useIsPlurallApp } from "features/plurall";

import { getAppVersion } from "../utils/functions/app";

export default function Logo(props: ComponentProps<typeof Box>) {
  const isPlurallApp = useIsPlurallApp();
  const region = useSelector(getRegion);
  const { height, width } = props;

  const logo = getLogo(
    isPlurallApp,
    region!,
    height,
    width as ResponsiveProp<string>
  );

  const title = `${getAppName()} ${getAppVersion()}`;

  return (
    <Box title={title} {...props}>
      {logo}
    </Box>
  );
}

function getLogo(
  isPlurallApp: boolean,
  region: string,
  height?: ResponsiveProp<string>,
  width?: ResponsiveProp<string>
) {
  const variant = isPlurallApp
    ? "plurall"
    : region === "GB"
    ? "default"
    : "goStudent";

  return <SenekitLogo variant={variant} height={height} width={width} />;
}
